<template>
    <table class="text-center font-weight-bold">
        <tr :class="[{'grey lighten-3': !input}]">
            <td rowspan="2" :class="[{'reportBorders': !input}]">Schnitt</td>
            <td rowspan="2" :class="[{'reportBorders': !input}]">Mannschaftsleistung</td>
            <td rowspan="2" :class="[{'reportBorders': !input}]">Tab.Pkt</td>
            <td :class="[{'reportBorders': !input}]">SP</td>
            <td rowspan="2" colspan="3" :class="[{'reportBorders': !input}]">Endergebnis</td>
            <td :class="[{'reportBorders': !input}]">SP</td>
            <td rowspan="2" :class="[{'reportBorders': !input}]">Tab.Pkt</td>
            <td rowspan="2" :class="[{'reportBorders': !input}]">Mannschaftsleistung</td>
            <td rowspan="2" :class="[{'reportBorders borderRight': !input}]">Schnitt</td>
        </tr>
        <tr :class="[{'grey lighten-3': !input}]">
            <td :class="[{'reportBorders': !input}]">M-LP</td>
            <td :class="[{'reportBorders': !input}]">M-LP</td>
        </tr>
        <tr :class="[{'white': !input}, {'greyCell': input}]" >
            <td :class="dataObject.getCSSColor('heim', 'schnitt', ['leftCell'])"
                rowspan="2">{{dataObject.heim.result.schnitt}}</td>
            <td :class="dataObject.getCSSColor('heim', 'kegel', ['leftCell'])"
                rowspan="2" style="max-width: 100px">{{dataObject.heim.result.kegel}}
                <div class="caption blue--text" style="line-height: 1.2;">
                    {{dataObject.getTeamRekordString('heim')}}
                </div>
            </td>
            <td :class="dataObject.getCSSColor('heim', 'tabPkt', ['leftCell'])"
                rowspan="2">{{dataObject.heim.result.tabPkt}}</td>
            <td :class="dataObject.getCSSColor('heim', 'sp', ['leftCell'])">
                {{dataObject.heim.result.sp}}</td>
            <td :class="dataObject.getCSSColor('heim', 'mp', ['leftCell'])">
                {{dataObject.heim.result.mp}}</td>
            <td class="leftCell">:</td>
            <td :class="dataObject.getCSSColor('gast', 'mp', ['leftCell'])">
                {{dataObject.gast.result.mp}}</td>
            <td :class="dataObject.getCSSColor('gast', 'sp', ['leftCell'])">
                {{dataObject.gast.result.sp}}</td>
            <td :class="dataObject.getCSSColor('gast', 'tabPkt', 'leftCell')"
                rowspan="2">{{dataObject.gast.result.tabPkt}}</td>
            <td :class="dataObject.getCSSColor('gast', 'kegel', ['leftCell'])"
                rowspan="2" style="max-width: 100px">{{dataObject.gast.result.kegel}}
                <div class="caption blue--text" style="line-height: 1.2;">
                    {{dataObject.getTeamRekordString('gast')}}
                </div>
            </td>
            <td :class="dataObject.getCSSColor('gast', 'schnitt', ['leftCell borderRight'])"
                rowspan="2">{{dataObject.gast.result.schnitt}}</td>
        </tr>
        <tr :class="[{'white': !input}, {'greyCell': input}]">
            <td :class="dataObject.getCSSColor('heim', 'mlp', ['secondRowCell'])">
                {{dataObject.heim.result.mlp}}</td>
            <td class="secondRowCell">{{dataObject.getKegelDeltaSign('heim')}}</td>
            <td class="secondRowCellBottom">{{dataObject.getKegelDelta()}}</td>
            <td class="secondRowCellBottom">{{dataObject.getKegelDeltaSign('gast')}}</td>
            <td :class="dataObject.getCSSColor('gast', 'mlp', ['secondRowCell'])">
                {{dataObject.gast.result.mlp}}</td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "spiel-bericht-edit-result",
        props: ['dataObject', 'input'],
    }
</script>

<style scoped>
    table {width: 100%; border-spacing: 0; table-layout: auto;}
    .greyCell { background-color: #eee }
    .leftCell {
        border-left: solid 1px grey;
        border-top: solid 1px grey;
        border-bottom: solid 1px grey;
    }
    .secondRowCell {
        border-left: solid 1px grey;
        border-bottom: solid 1px grey;
    }
    .secondRowCellBottom {
        border-bottom: solid 1px grey;
    }
    .reportBorders {
        border-left: solid 1px grey;
        border-top: solid 1px grey;
    }
    .borderRight {border-right: solid 1px grey; }
    /*tr { border-left: solid 1px grey; border-top: solid 1px grey}
    td {border-right: solid 1px grey; border-bottom: solid 1px grey}*/
</style>